// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyBWljg3gHyicKKUXwFF6gZregpPW1E2GdI',
    authDomain: 'pcele-3ef8d.firebaseapp.com',
    databaseURL: 'https://pcele-3ef8d.firebaseio.com',
    projectId: 'pcele-3ef8d',
    storageBucket: 'pcele-3ef8d.appspot.com',
    messagingSenderId: '807400690724'
  }
};
